import { render, staticRenderFns } from "./HomeEmployee.vue?vue&type=template&id=2307a2c0"
import script from "./HomeEmployee.vue?vue&type=script&lang=js"
export * from "./HomeEmployee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports